import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import RoleGuard from "../components/RoleGuard";

import Login from "../pages/Login";
import VerifyOTP from "../pages/VerifyOtp";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import AssessmentResult from "../pages/AssessmentResult";
import OAuthCallback from "../pages/OAuthCallback";

import ParentDashboard from "../pages/ParentDashboard";
import Consent from "../pages/Consent";

import LearnerDashboard from "../pages/LearnerDashboard";
import LearnerAssessment from "../pages/LearnerAssessment";
import Checkin from "../pages/Checkin";

import EducatorDashboard from "../pages/EducatorDashboard";
import InstitutionDashboard from "../pages/InstitutionDashboard";

import AdminDashboard from "../pages/AdminDashboard";
import Profile from "../pages/Profile";
import Unauthorized from "../pages/Unauthorized";
import NotFound from "../pages/NotFound";
import Signup from "../pages/Signup";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/oauth-callback" element={<OAuthCallback />} />

          {/* Parent */}
          <Route
            path="/parent"
            element={
              <RoleGuard allowed={["parent"]}>
                <ParentDashboard />
              </RoleGuard>
            }
          />
          <Route
            path="/parent/consent"
            element={
              <RoleGuard allowed={["parent"]}>
                <Consent />
              </RoleGuard>
            }
          />

          {/* Learner */}
          <Route
            path="/child"
            element={
              <RoleGuard allowed={["learner"]}>
                <LearnerDashboard />
              </RoleGuard>
            }
          />

          <Route
            path="/child/assessment"
            element={
              <RoleGuard allowed={["learner"]}>
                <LearnerAssessment />
              </RoleGuard>
            }
          />

          <Route
            path="/child/assessment/result"
            element={
              <RoleGuard allowed={["learner"]}>
                <AssessmentResult />
              </RoleGuard>
            }
          />

          <Route
            path="/child/checkin"
            element={
              <RoleGuard allowed={["learner"]}>
                <Checkin />
              </RoleGuard>
            }
          />

          {/* Educator */}
          <Route
            path="/educator"
            element={
              <RoleGuard allowed={["educator"]}>
                <EducatorDashboard />
              </RoleGuard>
            }
          />

          {/* Institution */}
          <Route
            path="/institution"
            element={
              <RoleGuard allowed={["institution"]}>
                <InstitutionDashboard />
              </RoleGuard>
            }
          />

          {/* Profile - All roles */}
          <Route
            path="/profile"
            element={
              <RoleGuard
                allowed={["admin", "parent", "learner", "educator", "institution"]}
              >
                <Profile />
              </RoleGuard>
            }
          />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <RoleGuard allowed={["admin"]}>
                <AdminDashboard />
              </RoleGuard>
            }
          />

          {/* System */}
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default Navigation;